module.exports = __webpack_public_path__ + "static/media/CNLOGO.c149ff8b.svg";